import type { QueryClient } from '@tanstack/react-query'
import type { NetworkEnvironment } from '@/hooks/useNetworkEnvironment'
import { userService } from '@/services/admin/userService'

export const ADMIN_NAVIGATION_STALE_TIME_MS = 5 * 60 * 1000
export const ADMIN_NAVIGATION_GC_TIME_MS = 10 * 60 * 1000

type AdminQueryOptions<TData> = {
  queryKey: readonly unknown[]
  queryFn: () => Promise<TData>
  staleTime: number
  gcTime: number
  refetchOnMount: true
  refetchOnWindowFocus: false
  refetchOnReconnect: false
}

export const buildDashboardMetricsQueryOptions = (
  currentEnv: NetworkEnvironment
) => ({
  queryKey: ['dashboard', 'metrics', currentEnv] as const,
  queryFn: () => userService.getDashboardMetrics(currentEnv),
  staleTime: ADMIN_NAVIGATION_STALE_TIME_MS,
  gcTime: ADMIN_NAVIGATION_GC_TIME_MS,
  refetchOnMount: true as const,
  refetchOnWindowFocus: false as const,
  refetchOnReconnect: false as const,
})

export const ensureAdminCriticalQuery = async <TData>(
  queryClient: QueryClient,
  options: AdminQueryOptions<TData>
) => {
  await queryClient.ensureQueryData(options)
}
